import styled from 'styled-components'
import { Box, get } from '@ally/metronome-ui'

export const BadgeWrapper = styled(Box)`
  ${({ theme: { colors, space } }): string => `
    > div {
      margin-bottom: ${space.xs};

      &:last-child {
        margin-bottom: 0;
      }

      > div {
        width: 100%;
        margin-left: ${space.xs};
        padding: ${space.xs} 0;
        border-bottom: 1px solid ${colors['slate-2']};
      }

      &:last-child {
        > div {
          border: none;
        }
      }
    }
  `}
`

export const BadgeIcon = styled.span<{ badgeType: string }>`
  ${({ badgeType, theme: { colors } }): string => `
    svg {
      width: 60px;
      height: 60px;
      -webkit-filter: drop-shadow( 3px 3px 2px ${colors['slate-2']});
      filter: drop-shadow( 3px 3px 2px ${colors['slate-2']});
      margin-top: ${badgeType === 'progress' ? '7px' : '0px'};    
    }
  `};
`

/*  _____________________
    ? Progress Bar Styles
    ---------------------  
*/
export const StyledProgressBorder = styled(Box)`
  height: 8px;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  background-color: ${get.colors('page-gray')};
`
export const StyledStatusBarBackground = styled.span<{ bgColor: string }>`
  transition: background-color 200ms linear;
  transition-delay: 1.5s;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  display: block;
  height: 100%;
  width: 100%;
  ${({ bgColor }): string => `
    background-color: ${bgColor};
  `}
`
export const StyledStatusBar = styled.span<{
  completionPercentage: number
}>`
  height: 8px;
  display: block;
  position: relative;
  transition-delay: 1s;
  transition: width 1.5s ease;

  ${({ completionPercentage }): string => `
    width: ${completionPercentage}%;
    &:before {
      top: 0;
      right: 0;
      width: 0;
      content: '';
      height: 100%;
      display: block;
      position: absolute;
    }
  `}
`
